
import Node from './node.vue'

export default {
  components: {Node},
  props: {
    widget: {type: Object, required: true}
  }
}
